export default __webpack_public_path__ + "static/media/IMG_0590.6fc0f5e4.jpeg";